import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSubtract = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [/* @__PURE__ */ _jsx("title", { children: "subtract" }), /* @__PURE__ */ _jsx("line", {
		x1: .75,
		y1: 12.038,
		x2: 23.25,
		y2: 12.038,
		fill: "none",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: "1.5px"
	})]
});
export { SvgSubtract as ReactComponent };
